// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3Q3PO","header":"MessagesList_header__pe4wG","chat":"MessagesList_chat__2qbA3"};